<template>
  <div class="page">
    <div class="card">
      <div class="topbar">
        <button type="button" class="back-btn" @click="$router.push('/profile')">
          ← Назад
        </button>
      </div>

      <div class="page-head">
        <h1>Настройки профиля</h1>
        <p>Здесь можно изменить данные аккаунта</p>
      </div>

      <form class="form" @submit.prevent="saveProfile">
        <div class="field">
          <label>ФИО</label>
          <input v-model.trim="form.FIO" type="text" placeholder="Введите ФИО" />
        </div>

        <div class="field">
          <label>Телефон</label>
          <input v-model.trim="form.phone" type="text" placeholder="+7 ..." />
        </div>

        <div class="field">
          <label>Telegram</label>
          <input v-model.trim="form.tg" type="text" placeholder="@username" />
        </div>

        <div class="field">
          <label>VK</label>
          <input v-model.trim="form.vk" type="text" placeholder="vk.com/username" />
        </div>

        <p v-if="errorMessage" class="message error">{{ errorMessage }}</p>
        <p v-if="successMessage" class="message success">{{ successMessage }}</p>

        <button type="submit" class="save-btn" :disabled="loading">
          {{ loading ? 'Сохраняем...' : 'Сохранить изменения' }}
        </button>
      </form>

      <button type="button" class="logout-btn" @click="logout">
        Выйти из аккаунта
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettingsView',
  data() {
    return {
      successMessage: '',
      form: {
        FIO: '',
        phone: '',
        tg: '',
        vk: ''
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/user']
    },
    loading() {
      return this.$store.getters['auth/loading']
    },
    errorMessage() {
      return this.$store.getters['auth/error']
    }
  },
  mounted() {
    this.form = {
      FIO: this.user?.FIO || '',
      phone: this.user?.phone || '',
      tg: this.user?.tg || '',
      vk: this.user?.vk || ''
    }
  },
  methods: {
    async saveProfile() {
      this.successMessage = ''
      await this.$store.dispatch('auth/clearError')

      const result = await this.$store.dispatch('auth/updateProfile', {
        FIO: this.form.FIO,
        phone: this.form.phone,
        tg: this.form.tg,
        vk: this.form.vk
      })

      if (!result || !result.ok) {
        return
      }

      this.successMessage = 'Данные профиля обновлены'
    },

    logout() {
      this.$store.dispatch('auth/logout')
      this.$store.dispatch('orders/clearOrdersCache')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.page {
  padding: 12px;
}

.card {
  max-width: 760px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 22px;
  padding: 22px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
}

.topbar {
  margin-bottom: 18px;
}

.back-btn {
  border: none;
  background: #eef2ff;
  color: #1d4ed8;
  padding: 12px 14px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
	font-size: 13px;
}

.page-head h1 {
  margin: 0 0 8px;
  font-size: 30px;
}

.page-head p {
  margin: 0 0 22px;
  color: #6b7280;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field label {
  display: block;
  margin-bottom: 8px;
  font-weight: 700;
}

.field input {
  width: 100%;
  border: 1px solid #dbe3f0;
  border-radius: 14px;
  padding: 14px 16px;
  background: #f8fafc;
  outline: none;
}

.message {
  margin: 0;
  padding: 14px 16px;
  border-radius: 14px;
}

.message.error {
  background: #f7dede;
  color: #c52f2f;
}

.message.success {
  background: #dff5e2;
  color: #1f7a33;
}

.save-btn {
  border: none;
  border-radius: 16px;
  background: #111827;
  color: #ffffff;
  min-height: 56px;
  font-weight: 700;
  cursor: pointer;
}

.save-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.logout-btn {
  width: 100%;
  margin-top: 22px;
  border: none;
  border-radius: 16px;
  background: #eef2ff;
  color: #1d4ed8;
  min-height: 56px;
  font-weight: 700;
  cursor: pointer;
}
</style>